import { render, staticRenderFns } from "./DialogLink.vue?vue&type=template&id=bdd8c63a&"
import script from "./DialogLink.vue?vue&type=script&lang=babel&"
export * from "./DialogLink.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports